import * as HELPERS from "./helper";
export default {
  install(app) {
    app.config.globalProperties.$helpers = HELPERS;
    // app.prototype.$helpers = HELPERS;
  },
};
